(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarEncabezadoFk(raiz) {
    var items = raiz.querySelectorAll('[data-encabezado-fk-item]');

    items.forEach(function (item) {
      var mega = item.querySelector('.encabezado-fk__mega');
      if (mega) {
        var padres = mega.querySelectorAll('[data-encabezado-fk-mega-padre]');
        padres.forEach(function (padre) {
          padre.addEventListener('mouseenter', function () {
            var indice = padre.getAttribute('data-encabezado-fk-mega-padre');
            padres.forEach(function (p) {
              p.classList.remove('encabezado-fk__mega-item--activo');
            });
            padre.classList.add('encabezado-fk__mega-item--activo');
            var listas = mega.querySelectorAll('[data-encabezado-fk-mega-hijos]');
            listas.forEach(function (lista) {
              if (lista.getAttribute('data-encabezado-fk-mega-hijos') === indice) {
                lista.classList.add('encabezado-fk__mega-hijos-lista--activa');
              } else {
                lista.classList.remove('encabezado-fk__mega-hijos-lista--activa');
              }
            });
          });
        });
      }
    });

    document.addEventListener('click', function (evento) {
      if (!raiz.contains(evento.target)) {
        items.forEach(function (item) {
          item.classList.remove('encabezado-fk__item-nav--abierto');
        });
      }
    });

    var botonAbrirMovil = raiz.querySelector('[data-encabezado-fk-abrir-movil]');
    var panelMovil = document.querySelector('[data-encabezado-fk-panel-movil]');
    var fondoMovil = document.querySelector('[data-encabezado-fk-fondo]');
    var botonCerrarMovil = document.querySelector('[data-encabezado-fk-cerrar-movil]');
    var listaRaiz = document.querySelector('[data-encabezado-fk-nivel-raiz]');

    function abrirPanelMovil() {
      if (panelMovil) panelMovil.classList.add('encabezado-fk__panel-movil--visible');
      if (fondoMovil) fondoMovil.classList.add('encabezado-fk__fondo-movil--visible');
      document.body.style.overflow = 'hidden';
    }

    function cerrarPanelMovil() {
      if (panelMovil) panelMovil.classList.remove('encabezado-fk__panel-movil--visible');
      if (fondoMovil) fondoMovil.classList.remove('encabezado-fk__fondo-movil--visible');
      document.body.style.overflow = '';
      document.querySelectorAll('.encabezado-fk__submenu-movil--visible').forEach(function (sub) {
        sub.classList.remove('encabezado-fk__submenu-movil--visible');
      });
      if (listaRaiz) listaRaiz.classList.remove('encabezado-fk__lista-movil--oculta');
    }

    if (botonAbrirMovil) {
      botonAbrirMovil.addEventListener('click', abrirPanelMovil);
    }
    if (botonCerrarMovil) {
      botonCerrarMovil.addEventListener('click', cerrarPanelMovil);
    }
    if (fondoMovil) {
      fondoMovil.addEventListener('click', cerrarPanelMovil);
    }

    document.querySelectorAll('[data-encabezado-fk-abrir-submenu]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var indice = boton.getAttribute('data-encabezado-fk-abrir-submenu');
        var submenu = document.querySelector('[data-encabezado-fk-submenu="' + indice + '"]');
        if (submenu) {
          submenu.classList.add('encabezado-fk__submenu-movil--visible');
          if (listaRaiz) listaRaiz.classList.add('encabezado-fk__lista-movil--oculta');
        }
      });
    });

    document.querySelectorAll('[data-encabezado-fk-volver]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var submenu = boton.closest('.encabezado-fk__submenu-movil');
        if (submenu) submenu.classList.remove('encabezado-fk__submenu-movil--visible');
        if (listaRaiz) listaRaiz.classList.remove('encabezado-fk__lista-movil--oculta');
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) {
        cerrarPanelMovil();
      }
    });
  }

  document.querySelectorAll('[data-encabezado-fk]').forEach(iniciarEncabezadoFk);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relacionados-fk"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('relacionados-fk-recomendaciones')) return;

  class RelacionadosFkRecomendaciones extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url) return;
      var elemento = this;
      fetch(url)
        .then(function (respuesta) {
          return respuesta.text();
        })
        .then(function (html) {
          var analizador = new DOMParser();
          var documento = analizador.parseFromString(html, 'text/html');
          var contenido = documento.querySelector('[data-relacionados-fk-contenido]');
          if (contenido) {
            elemento.innerHTML = '';
            elemento.appendChild(contenido);
          } else {
            elemento.remove();
          }
        })
        .catch(function () {
          elemento.remove();
        });
    }
  }

  customElements.define('relacionados-fk-recomendaciones', RelacionadosFkRecomendaciones);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zevra-blackfriday"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(numero) {
    return String(Math.max(0, numero)).padStart(2, '0');
  }

  function actualizarCountdown(contenedor) {
    var objetivo = contenedor.getAttribute('data-objetivo');
    if (!objetivo) return;
    var fechaObjetivo = new Date(objetivo.replace(' ', 'T')).getTime();
    if (isNaN(fechaObjetivo)) return;

    var elDias = contenedor.querySelector('[data-bf-fk-dias]');
    var elHoras = contenedor.querySelector('[data-bf-fk-horas]');
    var elMin = contenedor.querySelector('[data-bf-fk-min]');
    var elSeg = contenedor.querySelector('[data-bf-fk-seg]');

    function tick() {
      var restante = fechaObjetivo - Date.now();
      if (restante <= 0) {
        if (elDias) elDias.textContent = '00';
        if (elHoras) elHoras.textContent = '00';
        if (elMin) elMin.textContent = '00';
        if (elSeg) elSeg.textContent = '00';
        window.clearInterval(intervalo);
        window.location.reload();
        return;
      }
      var segundosTotales = Math.floor(restante / 1000);
      var dias = Math.floor(segundosTotales / 86400);
      var horas = Math.floor((segundosTotales % 86400) / 3600);
      var min = Math.floor((segundosTotales % 3600) / 60);
      var seg = segundosTotales % 60;

      if (elDias) elDias.textContent = pad(dias);
      if (elHoras) elHoras.textContent = pad(horas);
      if (elMin) elMin.textContent = pad(min);
      if (elSeg) elSeg.textContent = pad(seg);
    }

    tick();
    var intervalo = window.setInterval(tick, 1000);
  }

  function actualizarDifuminado(raiz) {
    var grid = raiz.querySelector('[data-bf-fk-grid]');
    if (!grid) return;

    var estado = raiz.getAttribute('data-bf-fk-estado');
    if (estado === 'antes') {
      // Todavía no ha abierto: las fotos se ocultan al máximo siempre,
      // sin importar cuántos días falten para el cierre.
      grid.style.setProperty('--bf-fk-blur', '22px');
      return;
    }

    var difuminadoActivo = raiz.getAttribute('data-bf-fk-difuminado-activo') === 'true';
    var diasDifuminado = parseInt(raiz.getAttribute('data-bf-fk-dias-difuminado'), 10) || 0;
    if (!difuminadoActivo || diasDifuminado <= 0) {
      grid.style.setProperty('--bf-fk-blur', '0px');
      return;
    }

    var finStr = raiz.getAttribute('data-bf-fk-fin');
    var finTs = new Date(finStr.replace(' ', 'T')).getTime();
    if (isNaN(finTs)) {
      grid.style.setProperty('--bf-fk-blur', '0px');
      return;
    }

    var inicioDifuminadoTs = finTs - diasDifuminado * 86400000;
    var ahora = Date.now();
    var progreso = (ahora - inicioDifuminadoTs) / (finTs - inicioDifuminadoTs);
    progreso = Math.max(0, Math.min(1, progreso));

    var blurMaximo = 16;
    var blurActual = Math.round(blurMaximo * (1 - progreso) * 10) / 10;
    grid.style.setProperty('--bf-fk-blur', blurActual + 'px');
  }

  document.querySelectorAll('[data-bf-fk]').forEach(function (raiz) {
    var countdowns = raiz.querySelectorAll('[data-bf-fk-countdown]');
    countdowns.forEach(actualizarCountdown);
    actualizarDifuminado(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zevra-carrusel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCarruselProductosFk(raiz) {
    var pista = raiz.querySelector('[data-carrusel-productos-fk-pista]');
    if (!pista) return;

    var botonAnterior = raiz.querySelector('[data-carrusel-productos-fk-anterior]');
    var botonSiguiente = raiz.querySelector('[data-carrusel-productos-fk-siguiente]');

    function anchoDesplazamiento() {
      var celda = pista.querySelector('.carrusel-productos-fk__celda');
      if (!celda) return pista.clientWidth;
      var estilo = window.getComputedStyle(pista);
      var gap = parseFloat(estilo.gap) || 0;
      return celda.getBoundingClientRect().width + gap;
    }

    function actualizarBotones() {
      if (!botonAnterior || !botonSiguiente) return;
      var maximo = pista.scrollWidth - pista.clientWidth - 2;
      botonAnterior.disabled = pista.scrollLeft <= 2;
      botonSiguiente.disabled = pista.scrollLeft >= maximo;
    }

    if (botonAnterior) {
      botonAnterior.addEventListener('click', function () {
        pista.scrollBy({ left: -anchoDesplazamiento(), behavior: 'smooth' });
      });
    }

    if (botonSiguiente) {
      botonSiguiente.addEventListener('click', function () {
        pista.scrollBy({ left: anchoDesplazamiento(), behavior: 'smooth' });
      });
    }

    pista.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizarBotones);
    }, { passive: true });

    window.addEventListener('resize', actualizarBotones);
    actualizarBotones();
  }

  document.querySelectorAll('[data-carrusel-productos-fk]').forEach(iniciarCarruselProductosFk);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zevra-galeria"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarGaleriaHoverFk(raiz) {
    var esTactilGrande = window.matchMedia('(hover: none) and (min-width: 990px)').matches;
    if (!esTactilGrande) return;

    var pares = raiz.querySelectorAll('[data-galeria-hover-fk-par]');

    pares.forEach(function (par) {
      var enlace = par.querySelector('.galeria-hover-fk__imagen-enlace');
      if (!enlace) return;

      enlace.addEventListener('click', function (evento) {
        var yaAbierto = par.classList.contains('galeria-hover-fk__par--abierto');
        var tienePromo = par.querySelector('.galeria-hover-fk__promo');
        if (tienePromo && !yaAbierto) {
          evento.preventDefault();
          pares.forEach(function (otro) {
            otro.classList.remove('galeria-hover-fk__par--abierto');
          });
          par.classList.add('galeria-hover-fk__par--abierto');
        }
      });
    });

    document.addEventListener('click', function (evento) {
      if (!raiz.contains(evento.target)) {
        pares.forEach(function (par) {
          par.classList.remove('galeria-hover-fk__par--abierto');
        });
      }
    });
  }

  document.querySelectorAll('[data-galeria-hover-fk]').forEach(iniciarGaleriaHoverFk);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zevra-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarEncabezadoFk(raiz) {
    var items = raiz.querySelectorAll('[data-encabezado-fk-item]');
    var esTactil = window.matchMedia('(hover: none)').matches;

    items.forEach(function (item) {
      var enlace = item.querySelector(':scope > .encabezado-fk__enlace-nav');
      if (enlace) {
        enlace.addEventListener('click', function (evento) {
          var desplegable = item.querySelector('.encabezado-fk__desplegable');
          if (desplegable) {
            evento.preventDefault();
            var estaAbierto = item.classList.contains('encabezado-fk__item-nav--abierto');
            items.forEach(function (otro) {
              otro.classList.remove('encabezado-fk__item-nav--abierto');
            });
            if (!estaAbierto) {
              item.classList.add('encabezado-fk__item-nav--abierto');
            }
          }
        });
      }

      var mega = item.querySelector('.encabezado-fk__mega');
      if (mega) {
        var padres = mega.querySelectorAll('[data-encabezado-fk-mega-padre]');
        padres.forEach(function (padre) {
          padre.addEventListener('mouseenter', function () {
            var indice = padre.getAttribute('data-encabezado-fk-mega-padre');
            padres.forEach(function (p) {
              p.classList.remove('encabezado-fk__mega-item--activo');
            });
            padre.classList.add('encabezado-fk__mega-item--activo');
            var listas = mega.querySelectorAll('[data-encabezado-fk-mega-hijos]');
            listas.forEach(function (lista) {
              if (lista.getAttribute('data-encabezado-fk-mega-hijos') === indice) {
                lista.classList.add('encabezado-fk__mega-hijos-lista--activa');
              } else {
                lista.classList.remove('encabezado-fk__mega-hijos-lista--activa');
              }
            });
          });
        });
      }
    });

    document.addEventListener('click', function (evento) {
      if (!raiz.contains(evento.target)) {
        items.forEach(function (item) {
          item.classList.remove('encabezado-fk__item-nav--abierto');
        });
      }
    });

    var botonAbrirMovil = raiz.querySelector('[data-encabezado-fk-abrir-movil]');
    var panelMovil = document.querySelector('[data-encabezado-fk-panel-movil]');
    var fondoMovil = document.querySelector('[data-encabezado-fk-fondo]');
    var botonCerrarMovil = document.querySelector('[data-encabezado-fk-cerrar-movil]');
    var listaRaiz = document.querySelector('[data-encabezado-fk-nivel-raiz]');

    function abrirPanelMovil() {
      if (panelMovil) panelMovil.classList.add('encabezado-fk__panel-movil--visible');
      if (fondoMovil) fondoMovil.classList.add('encabezado-fk__fondo-movil--visible');
      document.body.style.overflow = 'hidden';
    }

    function cerrarPanelMovil() {
      if (panelMovil) panelMovil.classList.remove('encabezado-fk__panel-movil--visible');
      if (fondoMovil) fondoMovil.classList.remove('encabezado-fk__fondo-movil--visible');
      document.body.style.overflow = '';
      document.querySelectorAll('.encabezado-fk__submenu-movil--visible').forEach(function (sub) {
        sub.classList.remove('encabezado-fk__submenu-movil--visible');
      });
      if (listaRaiz) listaRaiz.classList.remove('encabezado-fk__lista-movil--oculta');
    }

    if (botonAbrirMovil) {
      botonAbrirMovil.addEventListener('click', abrirPanelMovil);
    }
    if (botonCerrarMovil) {
      botonCerrarMovil.addEventListener('click', cerrarPanelMovil);
    }
    if (fondoMovil) {
      fondoMovil.addEventListener('click', cerrarPanelMovil);
    }

    document.querySelectorAll('[data-encabezado-fk-abrir-submenu]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var indice = boton.getAttribute('data-encabezado-fk-abrir-submenu');
        var submenu = document.querySelector('[data-encabezado-fk-submenu="' + indice + '"]');
        if (submenu) {
          submenu.classList.add('encabezado-fk__submenu-movil--visible');
          if (listaRaiz) listaRaiz.classList.add('encabezado-fk__lista-movil--oculta');
        }
      });
    });

    document.querySelectorAll('[data-encabezado-fk-volver]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var submenu = boton.closest('.encabezado-fk__submenu-movil');
        if (submenu) submenu.classList.remove('encabezado-fk__submenu-movil--visible');
        if (listaRaiz) listaRaiz.classList.remove('encabezado-fk__lista-movil--oculta');
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) {
        cerrarPanelMovil();
      }
    });
  }

  document.querySelectorAll('[data-encabezado-fk]').forEach(iniciarEncabezadoFk);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zevra-piepagina"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarToastNewsletterFk() {
    var toast = document.querySelector('[data-ppf-toast-exito]');
    if (!toast) return;

    var boton = toast.querySelector('[data-ppf-toast-cerrar]');
    var temporizador = window.setTimeout(cerrarToast, 6000);

    function cerrarToast() {
      window.clearTimeout(temporizador);
      toast.classList.add('pie-pagina-fk__toast-exito--salir');
      window.setTimeout(function () {
        toast.remove();
      }, 300);
    }

    if (boton) {
      boton.addEventListener('click', cerrarToast);
    }
  }

  iniciarToastNewsletterFk();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zevra-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarDiapositivasFk(raiz) {
    var diapositivas = raiz.querySelectorAll('[data-diapositivas-fk-diapositiva]');
    if (!diapositivas.length) return;

    var indicadores = raiz.querySelectorAll('[data-diapositivas-fk-indicador]');
    var indiceActual = 0;
    for (var i = 0; i < diapositivas.length; i++) {
      if (diapositivas[i].classList.contains('diapositivas-fk__diapositiva--activa')) {
        indiceActual = i;
        break;
      }
    }

    var autoplayActivo = raiz.getAttribute('data-autoplay') === 'true';
    var velocidad = parseInt(raiz.getAttribute('data-velocidad'), 10) || 5000;
    var pausarHover = raiz.getAttribute('data-pausar-hover') === 'true';
    var temporizador = null;

    function mostrar(indice) {
      diapositivas.forEach(function (diapositiva, posicion) {
        diapositiva.classList.toggle('diapositivas-fk__diapositiva--activa', posicion === indice);
      });
      indicadores.forEach(function (indicador, posicion) {
        indicador.classList.toggle('diapositivas-fk__indicador--activo', posicion === indice);
      });
      indiceActual = indice;
    }

    function siguiente() {
      mostrar((indiceActual + 1) % diapositivas.length);
    }

    function anterior() {
      mostrar((indiceActual - 1 + diapositivas.length) % diapositivas.length);
    }

    function detenerAutoplay() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    function iniciarAutoplay() {
      detenerAutoplay();
      if (autoplayActivo && diapositivas.length > 1) {
        temporizador = setInterval(siguiente, velocidad);
      }
    }

    var botonAnterior = raiz.querySelector('[data-diapositivas-fk-anterior]');
    var botonSiguiente = raiz.querySelector('[data-diapositivas-fk-siguiente]');

    if (botonAnterior) {
      botonAnterior.addEventListener('click', function () {
        anterior();
        iniciarAutoplay();
      });
    }

    if (botonSiguiente) {
      botonSiguiente.addEventListener('click', function () {
        siguiente();
        iniciarAutoplay();
      });
    }

    indicadores.forEach(function (indicador, posicion) {
      indicador.addEventListener('click', function () {
        mostrar(posicion);
        iniciarAutoplay();
      });
    });

    if (pausarHover) {
      raiz.addEventListener('mouseenter', detenerAutoplay);
      raiz.addEventListener('mouseleave', iniciarAutoplay);
    }

    iniciarAutoplay();
  }

  document.querySelectorAll('[data-diapositivas-fk]').forEach(iniciarDiapositivasFk);
})();

  } catch(e) { console.error(e); }
})();
})();
